import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ConfigurarPastaServiceService } from "app/configurar-pasta-service.service";
import { v4 as uuidv4 } from "uuid";
@Component({
  selector: "app-edit-propertie-dialog",
  templateUrl: "./edit-propertie-dialog.component.html",
  styleUrls: ["./edit-propertie-dialog.component.scss"],
})
export class EditPropertieDialogComponent implements OnInit, OnDestroy {
  public propForm: FormGroup;
  isLoading = false;
  public propCriate;
  public nomeFormatado;
  types: any[] = [
    { value: "d:text", inputType: "text" },
    { value: "d:mltext", inputType: "text" },
    { value: "d:int", inputType: "number" },
    { value: "d:long", inputType: "number" },
    { value: "d:float", inputType: "number" },
    { value: "d:double", inputType: "number" },
    { value: "d:date", inputType: "date" },
    { value: "d:datetime", inputType: "date" },
    { value: "d:boolean", inputType: "boolean" },
  ];
  listItems = [];
  typeData = "text";
  isPropEdited = false;
  isEdit: boolean = false;
  public idTipo;
  public clientId;
  public nameTipo: String;
  public idAspectoSaved;
  public tipoTitle: String;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<EditPropertieDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _snackBar: MatSnackBar,
    private configPastaService: ConfigurarPastaServiceService
  ) {
    this.dialogRef.beforeClose().subscribe((e) => {
      this.dialogRef.close(this.isPropEdited);
    });
  }

  ngOnInit() {
    this.propCriate = this.data.prop;
    this.clientId = this.data.clientId;
    this.idTipo = this.data.idDoTipo;

    this.idAspectoSaved = this.idTipo;
    console.log(this.propCriate, this.clientId, this.idTipo);
    this.getNomeTipo(this.idTipo);

    if (this.propCriate == null || this.propCriate == undefined) {
      this.isEdit = false;
      this.propForm = this.fb.group({
        name: [{ value: "", disabled: true }, Validators.required],
        title: ["", Validators.required],
        description: [""],
        dataType: ["", Validators.required],
        mandatory: ["", Validators.required],
        defaultVal: [""],
        constraint: [""],
        newProperty: [true],
      });
    } else {
      this.isEdit = true;
      this.propForm = this.fb.group({
        name: [
          { value: this.data.prop.name, disabled: true },
          Validators.required,
        ],
        title: [this.data.prop.title, Validators.required],
        description: [this.data.prop.description],
        dataType: [this.data.prop.type, Validators.required],
        mandatory: [this.data.prop.mandatory, Validators.required],
        defaultVal: [this.data.prop.defaultValue],
        constraint: [
          {
            value: this.data.prop.constraint
              ? this.data.prop.constraint.type
              : "none",
            disabled: true,
          },
        ],
        newProperty: [true],
      });
      this.onChangeConstraintEdit();
      this.onChangeTypeData(this.data.prop.type);
    }
  }
  getNomeTipo(id) {
    this.configPastaService.getNomeTipo(id).subscribe(
      (data) => {
        console.log(data);
        const fullName = data.name;
        const splitFullName = fullName.split(":");
        const prefix = splitFullName[0];
        this.nameTipo = prefix;
        this.tipoTitle = data.title;
      },
      (error) => {
        console.error(error);
      }
    );
  }
  formatarNome(nome) {
    const str = nome;
    const wordsIgnored = [
      " da ",
      " das ",
      " DAS ",
      " DA ",
      " DO ",
      " DE ",
      " DOS ",
      " de ",
      " do ",
      " dos ",
      " Da ",
      " Das ",
      " De ",
      " Do ",
      " Dos ",
      " ",
    ];
    const re = new RegExp("\\b(" + wordsIgnored.join("|") + ")\\b", "g");
    const nameFormated = str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()@¨+]/g, "")
      .replace(re, "")
      .replace(/[ ]{2,}/, " ");
    this.nomeFormatado = nameFormated;
    const nomeFormat = `${this.nameTipo}:${nameFormated}`;
    this.propForm.get("name").setValue(nomeFormat);
  }

  keyFunc(e) {
    this.formatarNome(e.target.value);
  }

  onChangeConstraintEdit() {
    console.log("Edit: " + this.isEdit);
    console.log(this.propForm.get("constraint").value);
    if (this.isEdit) {
      if (this.propForm.get("constraint").value === "REGEX") {
        this.propForm.removeControl("list");
        this.listItems = [];

        this.propForm.addControl(
          "regex",
          new FormControl(
            this.data.prop.constraint
              ? this.data.prop.constraint.expression
              : null,
            Validators.required
          )
        );
      } else if (this.propForm.get("constraint").value === "LIST") {
        this.propForm.removeControl("regex");

        if (this.data.prop.constraint && this.data.prop.constraint.listaItens) {
          this.listItems = [...this.data.prop.constraint.listaItens];
        }

        this.propForm.addControl(
          "list",
          new FormControl(this.listItems, Validators.required)
        );
      } else {
        this.propForm.removeControl("list");
        this.listItems = [];
        this.propForm.removeControl("regex");
      }
    }
  }

  onChangeConstraintCriate(constraint) {
    // console.log(constraint);
    console.log(this.isEdit);

    if (constraint === "LIST") {
      this.propForm.get("constraint").setValue("LIST");
      this.propForm.removeControl("regex");
      this.propForm.addControl(
        "list",
        this.fb.array([])
        // new FormControl(this.listItems, Validators.required)
      );
    } else if (constraint === "REGEX") {
      this.propForm.get("constraint").setValue("REGEX");
      this.propForm.removeControl("list");
      this.listItems = [];
      this.propForm.addControl(
        "regex",
        new FormControl("", Validators.required)
      );
    } else {
      this.propForm.get("constraint").setValue(null);
      this.propForm.removeControl("list");
      this.listItems = [];
      this.propForm.removeControl("regex");
    }
  }

  get list() {
    return this.propForm.get("list") as FormArray;
  }
  onChangeTypeData(typeSelected) {
    if (this.data.prop == undefined) {
      const obj = this.types.find((e) => e.value === typeSelected);
      this.typeData = obj.inputType;
    }
  }

  addInput() {
    this.listItems.push({ id: null, value: null });
    console.log(this.listItems);
  }

  addItemList() {
    this.list.push(this.fb.control(""));
  }

  delItem(index) {
    this.listItems.splice(index, 1);
  }

  deleteItem(index) {
    if (index > 0) {
      this.list.removeAt(index);
      this.listItems.pop();
      // this.list.
    } else {
      this.openSnackBar("O primeiro item da lista é obrigatório !", true);
    }
  }

  ngOnDestroy() {
    if (this.data.prop.constraint && this.data.prop.constraint.listaItens) {
      this.listItems = [...this.data.prop.constraint.listaItens];
    }
  }

  saveData() {
    if (this.isEdit == true) {
      console.log(this.isEdit);
      this.isLoading = true;
      // console.log(this.listItems);
      // console.log(this.propForm);

      const propToSave: any = {
        defaultValue: this.propForm.get("defaultVal").value,
        id: this.data.prop.id,
        mandatory: this.propForm.get("mandatory").value,
        name: this.data.prop.name,
        title: this.propForm.get("title").value,
        type: this.propForm.get("dataType").value,
      };

      switch (this.propForm.get("constraint").value) {
        case "none":
          propToSave.constraint = null;
          break;
        case "LIST":
          if (this.data.prop.constraint) {
            propToSave.constraint = { ...this.data.prop.constraint };
            propToSave.constraint.expression = null;
            propToSave.constraint.listaItens = this.listItems;
            propToSave.constraint.type = "LIST";
          }

          break;
        case "REGEX":
          if (this.data.prop.constraint) {
            propToSave.constraint = { ...this.data.prop.constraint };
            propToSave.constraint.expression = this.propForm.get("regex").value;
            propToSave.constraint.listaItens = null;
            propToSave.constraint.type = "REGEX";
          }
          break;
      }

      // console.log(propToSave);
      this.configPastaService.editProperty(propToSave).subscribe(
        (data) => {
          // console.log(data);

          this.isLoading = false;
          this.isPropEdited = true;
          this.openSnackBar("propriedade atualizada com sucesso!", false);
        },
        (err) => {
          console.error(err);
          this.openSnackBar(
            "Ocorreu um erro ao atualizar propriedade, tente novamente em alguns instantes",
            true
          );
          this.isLoading = false;
        }
      );
    } else {
      if (this.propForm.valid) {
        const constraintNula: any = {
          expression: "",
          listaItens: "",
          type: "",
        };
        this.isLoading = true;
        // console.log(this.listItems);
        // console.log(this.propForm);

        const propToSave: any = {
          defaultVal: this.propForm.get("defaultVal").value,
          mandatory: this.propForm.get("mandatory").value,
          name: this.propForm.get("name").value,
          title: this.propForm.get("title").value,
          dataType: this.propForm.get("dataType").value,
          newProperty: this.propForm.get("newProperty").value,
          description: this.propForm.get("description").value,
        };

        switch (this.propForm.get("constraint").value) {
          case "none":
            propToSave.constraint = null;
            break;
          case "LIST":
            propToSave.constraint = { ...constraintNula };
            propToSave.constraint.name = `${this.nameTipo}:LIST_${uuidv4()}`;
            propToSave.constraint.expression = null;
            const listaItems = [];
            const lista: any[] = this.propForm.value.list;
            lista.forEach((el) => {
              listaItems.push({ id: null, value: el });
            });
            propToSave.constraint.listaItens = listaItems;
            propToSave.constraint.type = "LIST";
            break;
          case "REGEX":
            propToSave.constraint = { ...constraintNula };
            propToSave.constraint.name = `${this.nameTipo}:REGEX_${uuidv4()}`;
            propToSave.constraint.expression = this.propForm.get("regex").value;
            propToSave.constraint.listaItens = null;
            propToSave.constraint.type = "REGEX";
            break;
        }

        console.log(propToSave);

        this.configPastaService
          .saveProperty(propToSave, this.idAspectoSaved)
          .subscribe(
            async (data) => {
              console.log(data);
              this.isLoading = false;
              await this.openSnackBar(
                "propriedade adicionada com sucesso!",
                false
              );

              await this.configPastaService.isChangedNode.next();
            },
            (err) => {
              console.error(err);
              this.openSnackBar(
                "Ocorreu um erro ao adicionar propriedade, tente novamente em alguns instantes",
                true
              );
              this.isLoading = false;
            }
          );
      }
    }
  }
  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, "", {
      horizontalPosition: "right",
      verticalPosition: "top",
      duration: 3000,
      panelClass: isErr ? ["error-snackbar"] : ["success-snackbar"],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/dialog/edit-propertie-dialog/edit-propertie-dialog.component.ts